import type { MonospaceOrgSettings } from '#layers/data-model/public';
import { withItemType } from '@rstore/vue';
import { SINGLETON_KEY } from '#layers/base/public';
import { MONOSPACE_SCOPE_ID } from '#layers/data-model/public';

export const OrgSettings = withItemType<MonospaceOrgSettings>().defineCollection({
	getKey: () => SINGLETON_KEY,
	name: 'MonospaceOrgSettings',
	scopeId: MONOSPACE_SCOPE_ID,
	meta: {
		singleton: true,
		defaultFields: ['name', 'color', 'logoId'],
		endpoint: 'system/settings',
	},
});
